module.exports = __webpack_public_path__ + "media/images/influence-icon-9b1f39e6.svg";